/**
 * スクロールアニメーション IntersectionObserver API
 */
document.addEventListener('DOMContentLoaded', () => {
  const fadeinItems = document.querySelectorAll('.js-fadein');

  const fadeinObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const fadeinElement = entry.target;
      fadeinElement.classList.add('is-scrolled');

      // 一度表示したら監視解除（再アニメ不要なら）
      observer.unobserve(fadeinElement);
    });
  }, {
    root: null,
    rootMargin: '0px 0px -15% 0px', // 少し早めに発火したいときは正の値に
  });

  fadeinItems.forEach(fadeinElement => fadeinObserver.observe(fadeinElement));
});